import { observer, inject } from 'mobx-react';

export const injectStore = (fn) => inject('store')(observer(fn));
export default injectStore;
